import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import classNames from 'classnames';

import type { ImageSelectOptionType } from 'js/src/components/common/ui/ImageSelect/ImageSelect';

const CustomImageOption = <T, Option extends ImageSelectOptionType<T>>(
    props: OptionProps<Option, boolean, any>,
) => {
    const { children, className, data, isDisabled, isFocused, isSelected } = props;
    // override the className
    const newClassName = classNames(
        {
            option: true,
            'option--is-disabled': isDisabled || data.disabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected,
        },
        className,
        'd-flex',
        'align-items-center',
        'custom-option',
    );

    return (
        <components.Option className={newClassName} {...props}>
            <img src={data.picture_url ?? ''} alt={String(data.label)} loading="lazy" />
            {children}
        </components.Option>
    );
};

export default CustomImageOption;
